import * as ec from '../tracking/event-collector';
import * as prometheus from '../tracking/prometheus';
import { TrackingData } from '../../components/types';

export function addClickEventsEventCollector (container: HTMLElement, options: TrackingData) {
    const items = container.querySelectorAll('[data-finn-adid]');
    [].forEach.call(items, (div: HTMLDivElement) => {
        div.addEventListener('click', function (ev) {
            ec.trackClickRecommendation.call(this, ev, options);
        });
    });
}

export function addClickEventsPrometheus (container: HTMLElement) {
    const items = container.querySelectorAll('[data-finn-adid]');
    [].forEach.call(items, (div: HTMLDivElement) => {
        div.addEventListener('click', prometheus.logClick);
    });
}
